import { render, staticRenderFns } from "./AtualizarGrupoDeRotas.vue?vue&type=template&id=75513766&"
import script from "./AtualizarGrupoDeRotas.vue?vue&type=script&lang=js&"
export * from "./AtualizarGrupoDeRotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports